// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "common" + "." + "dfa954c622a09a0f6cb1" + ".css";
};